import React, { ChangeEvent, useContext, useState } from 'react'

import styled from 'styled-components'

import LiveModal from 'live/components/ui/Modal'
import i18n from 'live/services/i18n'

import { TemporaryDataType, TemporarySetDataType } from '../useTemporaryDataState'
import { deleteEntityAndItsChildren } from '../../utils/actions'
import { StaticDataImporterContext } from '../../context/StaticDataImporterContext'

interface ExportDataModalProps {
    showDecisionModal: boolean
    setShowDecisionModal: (value: boolean) => void
    data: TemporaryDataType
    setData: TemporarySetDataType
}

export const DecisionModal = ({ showDecisionModal, setShowDecisionModal, data, setData }: ExportDataModalProps) => {
    const [selectedRadio, setSelectedRadio] = useState('DISCARD_DRAFT')

    const { checkedRows, setCheckedRows, setCheckedToTransfer, setIsValidToTransfer } = useContext(
        StaticDataImporterContext
    )

    const handleSelectedRadioChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSelectedRadio(event.target.value)
    }

    const handleKeepOrDiscardData = (isDiscardDraft: boolean): void => {
        if (isDiscardDraft) {
            // In the previous step, it validates that there is only one selected well
            const wells: WellDto[] = Object.keys(checkedRows)
                .filter(key => key.startsWith('wells=>'))
                .flatMap(key => checkedRows[key] as WellDto[])

            wells.forEach(well => {
                const wellId = well.rowId

                deleteEntityAndItsChildren(wellId, true).then(() => {
                    setData.setWells(prev => prev.filter(item => item.rowId !== wellId))
                    setCheckedRows(null)
                    setCheckedToTransfer(null)
                })
            })
        }

        if (!isDiscardDraft) {
            window.location.reload()
        }

        setShowDecisionModal(false)
        setSelectedRadio('DISCARD_DRAFT')
        setIsValidToTransfer(false)
    }

    return (
        <LiveModalWrapper show={showDecisionModal}>
            <LiveModal.Header>
                <LiveModal.Title>
                    <span>{i18n('Draft table')}</span>
                </LiveModal.Title>
            </LiveModal.Header>
            <LiveModal.Body>
                <span className="first-span">
                    {i18n('draftQuestionMessage')} <b>{i18n('draftBoldQuestionMessage')}</b>
                </span>
                {/* <span className="second-span">{i18n('What do you want to do with the draft table?')}</span> */}
                <div className="radio">
                    <input
                        type="radio"
                        id="discard-draft-radio"
                        name="discard"
                        value="DISCARD_DRAFT"
                        checked={selectedRadio === 'DISCARD_DRAFT'}
                        onChange={handleSelectedRadioChange}
                    />
                    <label htmlFor="discard-draft-radio">{i18n('Discard the draft table')}</label>
                </div>
                <div className="radio">
                    <input
                        type="radio"
                        id="keep-draft-radio"
                        name="keep"
                        value="KEEP_DRAFT"
                        checked={selectedRadio === 'KEEP_DRAFT'}
                        onChange={handleSelectedRadioChange}
                    />
                    <label htmlFor="keep-draft-radio">{i18n('Keep the draft table')}</label>
                </div>
            </LiveModal.Body>
            <LiveModal.Footer>
                <ActionBtn
                    onClick={() => handleKeepOrDiscardData(selectedRadio === 'DISCARD_DRAFT')}
                    className="btn btn-primary"
                >
                    {i18n('Confirm')}
                </ActionBtn>
            </LiveModal.Footer>
        </LiveModalWrapper>
    )
}

const LiveModalWrapper = styled(LiveModal)`
    display: flex !important;

    .modal-dialog {
        margin: auto;
        width: 400px;

        .modal-header {
            .close-btn {
                position: absolute;
                top: 16px;
                right: 25px;
                z-index: 9999;

                cursor: pointer;
            }
        }
    }

    .modal-body {
        display: flex;
        flex-direction: column;

        .first-span {
            margin: 12px 0;
        }

        .radio {
            display: flex;
            align-items: center;
            gap: 4px;

            label {
                font-size: 12px;
                font-family: SourceSansPro-Regular, Arial, Helvetica Neue, Helvetica, sans-serif;
                padding-bottom: 0;
            }
        }

        input[type='radio']::after {
            top: 3px;
            left: 3px;
        }
    }
`
const ActionBtn = styled.button`
    font-size: 13px;
    font-weight: 600;
    padding: 6px 12px;

    border: none;
    border-radius: 3px;

    &.btn.btn-primary {
        border: 1px solid var(--blue-500);
        color: white;
        background-color: var(--blue-500);

        &:hover {
            opacity: 0.8;
        }
    }
`
